import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main:"#fe5000",
     
    },
    secondary: {
      main: "#fff",
    },
    openPay: {
      main: "#1b5e20",
    },
  },
  typography: {
    fontFamily: ` "Open Sans", "sans-serif";`,
  },
});
